export default __webpack_public_path__ + "static/media/JuniorGPStage22024.ef12a527.png";